/*
 *
 * LoginPage reducer
 *
 */
import produce from 'immer';
import { GET_RECOVERY_LINK_ACTIONTYPE, LOGIN_ACTIONTYPE, RESET_RECOVERY_FORM_ACTIONTYPE } from './actionTypes';
import { RESET_APP_DATA_ACTIONTYPE } from '../../appContainer/actionTypes';

export const initialState = {
  isLoginDone: false,
  isError: '',
  error: '',
  isLoading: false,
  isRecoveryLinkComplete: false,
  isRecoveryLinkError: false,
  isRecoveryLinkEmail: '',
};

/* eslint-disable default-case, no-param-reassign */
const loginPageReducer = produce((draft, action) => {
  switch (action.type) {
    case LOGIN_ACTIONTYPE.SUCCESS:
      draft.isLoginDone = true;
      break;
    case LOGIN_ACTIONTYPE.LOADING:
      draft.isLoading = action.loading;
      break;
    case LOGIN_ACTIONTYPE.FAILURE:
      draft.isError = true;
      draft.errorMsg = action.error;
      break;
    case LOGIN_ACTIONTYPE.RESET:
      draft = initialState;
      break;
    case GET_RECOVERY_LINK_ACTIONTYPE.SUCCESS: {
      draft.isRecoveryLinkError = '';
      draft.isRecoveryLinkEmail = action.payload;
      break;
    }
    case GET_RECOVERY_LINK_ACTIONTYPE.FAILURE: {
      draft.isRecoveryLinkError = action.payload;
      draft.isRecoveryLinkEmail = '';
      break;
    }
    case GET_RECOVERY_LINK_ACTIONTYPE.LOADING: {
      draft.isRecoveryLinkComplete = !action.payload;
      if (action.payload) {
        draft.isRecoveryLinkError = '';
        draft.isRecoveryLinkEmail = '';
      }
      break;
    }
    case RESET_RECOVERY_FORM_ACTIONTYPE.COMPLETED: {
      draft.isRecoveryLinkComplete = false;
      draft.isRecoveryLinkError = '';
      draft.isRecoveryLinkEmail = '';
      break;
    }
    case RESET_APP_DATA_ACTIONTYPE.TRIGGER:
      return initialState;
  }
}, initialState);

export default loginPageReducer;
